
/**
 * 电子回单-导出记录
 */
<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/payCenter/electronicReceipt' }"
        >电子回单</el-breadcrumb-item
      >
      <el-breadcrumb-item>导出记录</el-breadcrumb-item>
    </el-breadcrumb>
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      element-loading-text="拼命加载中"
      style="width: 100%; margin-top: 20px"
    >
      <el-table-column prop="typeDesc" label="导出类型"> </el-table-column>
      <el-table-column prop="statusDesc" label="导出进度">
        <template slot-scope="scope">
          <span :style="{ color: getStatusColor(scope.row.status) }">
            {{ scope.row.statusDesc }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        show-overflow-tooltip
        min-width="200"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.remark || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdAtStr" label="导出时间"> </el-table-column>
      <el-table-column fixed="right" align="center" label="操作">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status === 2"
            size="small"
            type="primary"
            plain
            @click="download(scope.row.downloadUrl)"
            >下载</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
  </div>
</template>

<script>
import { exportEreceiptLogs } from "../../api/userMG";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      loading: false,
      formInline: {
        page: 1,
        pageSize: 10,
      },
      listData: [],
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  components: {
    Pagination,
  },
  created() {
    this.getdata(this.formInline);
  },
  methods: {
    getStatusColor(status) {
      switch (status) {
        case 0:
          return "#909399"; // 待处理
        case 1:
          return "#409EFF"; // 处理中
        case 2:
          return "#67C23A"; // 导出完成
        case 3:
          return "#F56C6C"; // 导出失败
        default:
          return "#909399";
      }
    },
    download(url) {
      window.open(url);
    },
    getdata(parameter) {
      this.loading = true;
      exportEreceiptLogs(parameter)
        .then((res) => {
          this.loading = false;
          if (res.msg != "success") {
            this.$message({
              type: "error",
              message: res.msg,
            });
          } else {
            this.listData = res.data.items;
            this.pageparm.page = res.data.page;
            this.pageparm.pageSize = res.data.pageSize;
            this.pageparm.total = res.data.totalCount;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/payCenter/electronicReceiptExportList.vue